<template>
  <v-container>
    <page-title title="Download files" class="mb-3"></page-title>
    <v-spacer></v-spacer>
    <!--search-form wrapper <v-input-->
    <v-form @submit.prevent="search" style="width: 100%">
      <v-text-field
        v-model="query"
        :rules="search_rules"
        outlined
        label="Search"
        required
        @click:append="search"
        append-icon="mdi-magnify"
        placeholder="Search note and past question"
        class="text-capitalize"
      ></v-text-field>
    </v-form>

    <h4 class="grey-text d-none">
      <v-icon color="var(--grey)" class="px-2">mdi-tune</v-icon>Search Filters
    </h4>
    <v-row class="my-2 d-none">
      <!-------filter of file type------->
      <v-col cols="12" sm="6">
        <p class="sub-hero-text mb-2">type</p>
        <v-chip-group column active-class="primary--text">
          <v-chip filter outlined label @click="getFileType('question')"
            >Past questions</v-chip
          >
          <v-chip filter outlined label @click="getFileType('note')"
            >Lecture notes</v-chip
          >
          <v-chip filter outlined label @click="getFileType('all')">All</v-chip>
        </v-chip-group>
      </v-col>

      <!-------filter of file age-------->
      <v-col cols="12" sm="6">
        <p class="sub-hero-text mb-2">date uploaded</p>
        <v-chip-group column active-class="pink--text">
          <v-chip filter outlined label @click="getFileAge('recent')"
            >Most recent</v-chip
          >
          <v-chip filter outlined label @click="getFileAge('older')"
            >Older</v-chip
          >
          <v-chip filter outlined label @click="getFileAge('all')">All</v-chip>
        </v-chip-group>
      </v-col>

      <!--------level ------>
      <v-col cols="12" sm="6">
        <p class="sub-hero-text mb-2">level</p>
        <v-chip-group column active-class="pink--text">
          <v-chip filter outlined label @click="getLevel('1')"
            >100 level</v-chip
          >
          <v-chip filter outlined label @click="getLevel('2')"
            >200 level</v-chip
          >
          <v-chip filter outlined label @click="getLevel('3')"
            >300 level</v-chip
          >
          <v-chip filter outlined label @click="getLevel('4')"
            >400 level</v-chip
          >
          <v-chip filter outlined label @click="getLevel('5')"
            >500 level</v-chip
          >
          <v-chip filter outlined label @click="getLevel('6')"
            >600 level</v-chip
          >
        </v-chip-group>
      </v-col>

      <!---------semester------------->
      <v-col cols="12" sm="6">
        <p class="sub-hero-text mb-2">semester</p>
        <v-chip-group column active-class="primary--text">
          <v-chip filter outlined label @click="getSemester('1')"
            >First semester</v-chip
          >
          <v-chip filter outlined label @click="getSemester('2')"
            >Second semester</v-chip
          >
        </v-chip-group>
      </v-col>
      <v-col cols="12" sm="6" class="d-none">
        <v-btn color="var(--purple)" dark @click="search"
          >Search <v-icon right>mdi-rocket-launch-outline</v-icon></v-btn
        >
        <v-btn color="var(--red)" outlined class="ml-2"
          >Clear Fields<v-icon right>mdi-close-outline</v-icon></v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageTitle from "../../components/PageTitle.vue";
export default {
  components: {
    PageTitle,
  },
  data: () => ({
    query: "",
    fileType: null,
    fileAge: null,
    level: null,
    semester: null,
    exactMatch: false,
    search_rules: [(v) => v.length >= 3 || "Please provide longer search term"],
  }),

  mounted() {
    //if the file type change from "all" to other types, cause the change
  },

  computed: {
    filter() {
      return {
        type: this.fileType,
        age: this.fileAge,
        match: this.exactMatch,
        level: this.level,
        semester: this.semester,
      };
    },
  },
  methods: {
    search() {
      //define search filter and pass it as argz to the search handler
      //parse the processed data to the next route as query params
      this.$router.push({
        name: "search-result",
        params: {
          query: encodeURIComponent(this.query),
          filters: { ...this.filter },
        },
      });
    },
    getFileType(type) {
      this.fileType = type;
    },
    getFileAge(age) {
      this.fileAge = age;
    },
    getLevel(level) {
      this.level = level;
    },
    getSemester(semester) {
      this.semester = semester;
    },
  },
};
</script>
<style scoped>
.v-radio {
  text-transform: capitalize;
}
.purple-text {
  color: var(--purple);
}
.v-radio-group h5 {
  color: var(--grey);
}
</style>